import { Outlet } from "react-router-dom";
import { BottomNav } from "@components/layout";

/**
 * AppShellLayout — used for routes that show the persistent bottom
 * navigation (Home, Search, Favorites, Profile). Routes with their own
 * full-screen flow and sticky footer (Property Details, Add Property,
 * Chat conversation) use BareLayout instead — see router/index.jsx.
 */
export default function AppShellLayout() {
  return (
    <>
      <Outlet />
      <BottomNav />
    </>
  );
}
